exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".styles__autoResizeTextArea___2kIne {\n  overflow-y: auto !important;\n  -webkit-overflow-scrolling: touch; }\n  .styles__autoResizeTextArea___2kIne textarea {\n    overflow-y: auto !important;\n    -webkit-overflow-scrolling: touch;\n    scroll-padding-bottom: 8px; }\n", ""]);

// exports
exports.locals = {
	"autoResizeTextArea": "styles__autoResizeTextArea___2kIne"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"modules":true,"sourceMap":false,"minimize":true,"importLoaders":2,"localIdentName":"[name]__[local]___[hash:base64:5]"}!./node_modules/sass-loader/lib/loader.js?{"includePaths":["./src"]}!./src/components/AutoResizeTextArea/styles.scss
// module id = 1950
// module chunks = 6